module.exports = __webpack_public_path__ + "static/media/image 36.103b4e07.png";